import React from "react";
import Tippy from "@tippyjs/react";
import toast from "react-hot-toast";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-regular-svg-icons";
import { useClientContext } from "../../hooks/ClientContext";
import { OverlayTrigger, Popover } from "react-bootstrap"
import styled from "styled-components";
import { openClientVulnerabilityModal } from "../../components/modals/client-factfind-vulnerability";
import { toNString } from "../../helpers/guids";
import useOpenMasterAccount from "../../hooks/useOpenMasterAccount";

const LargePopover = styled(Popover)`
max-width: 500px;
`;

const ClientInfo = () => {
    const { account, addToFavourites, removeFromFavourites } = useClientContext();
    const { accountReference, accountName, adviser, reviewAdviser, typeDescription, isFavourited, isVulnerable, notes, masterAccountId } = account || {};
    const openMasterAccount = useOpenMasterAccount();

    const onFavouriteChanged = () => {
        if (isFavourited) {
            toast.promise(removeFromFavourites(), {
                loading: `Processing...`,
                success: () => `The client has been removed from your favourites.`,
                error: (err) => {
                    const { message } = err || { message: 'There was an unkown error.' };
                    return message;
                }
            });
        }
        else {
            toast.promise(addToFavourites(), {
                loading: `Processing...`,
                success: () => `The client has been added to your favourites.`,
                error: (err) => {
                    const { message } = err || { message: 'There was an unkown error.' };
                    return message;
                }
            });
        }
    };

    const onOpenClientVulnerabilityModal = (masterAccountId) => {
        openClientVulnerabilityModal(masterAccountId)
            .then(
                (proceed) => {
                    if (proceed) {
                        const sectionStorageKey = `${toNString(masterAccountId)}-fact-find-sections`;
                        const activeKeys = JSON.parse(sessionStorage.getItem(sectionStorageKey)) ?? [];
                        if (!activeKeys.includes("vulnerability")) {
                            activeKeys.push("vulnerability");
                            sessionStorage.setItem(sectionStorageKey, JSON.stringify(activeKeys));
                        }
                        openMasterAccount(masterAccountId, { suffix: "factfind" });
                    }
                }
            );
    }

    return (
        <>
            <div className="d-flex flex-fill align-items-center">
                <Tippy placement="left" content={(
                    <p className="m-0">
                        <span className="fw-bold">Type:</span> <span>{typeDescription ?? "Unknown"}</span>
                        <br />
                        <span className="fw-bold">Adviser:</span> <span>{adviser ?? "None"}</span>
                        <br />
                        <span className="fw-bold">Review Adviser:</span> <span>{reviewAdviser ?? "None"}</span>
                    </p>
                )}>
                    <div className="me-2">
                        <FontAwesomeIcon
                            size="lg"
                            onClick={onFavouriteChanged}
                            icon={isFavourited ? 'fa-star' : faStar}
                            className={classnames('has-pointer', {
                                'text-white': !isFavourited,
                                'text-gold': isFavourited
                            })}
                        />
                    </div>
                </Tippy>
                <h1 className="fs-4 m-0">{accountReference} - {accountName}</h1>
                {isVulnerable && (<OverlayTrigger
                    placement="right"
                    overlay={<LargePopover>
                        <Popover.Header>Notes</Popover.Header>
                        <Popover.Body>
                            <div style={{ textAlign: "left" }}>
                                <span>{notes}</span>
                            </div>
                        </Popover.Body>
                    </LargePopover>}>
                    <span
                        className="badge rounded-pill bg-danger p-2 ms-2"
                        style={{ cursor: "pointer" }}
                        onClick={() => onOpenClientVulnerabilityModal(masterAccountId)}>
                        Vulnerable Client
                    </span>
                </OverlayTrigger>)}
            </div>
        </>
    );
};

export default ClientInfo;